"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterResumeHashPlugin = void 0;
const anonymizeResumeHash_1 = require("../lib/anonymizeResumeHash");
const transform = (ctx) => {
    var _a;
    try {
        const { page } = (_a = ctx.event) === null || _a === void 0 ? void 0 : _a.context;
        if (page === null || page === void 0 ? void 0 : page.referrer) {
            page.referrer = (0, anonymizeResumeHash_1.anonymizeResumeHash)(page.referrer);
        }
        if (page === null || page === void 0 ? void 0 : page.search) {
            page.search = (0, anonymizeResumeHash_1.anonymizeResumeHash)(page.search);
        }
        if (page === null || page === void 0 ? void 0 : page.url) {
            page.url = (0, anonymizeResumeHash_1.anonymizeResumeHash)(page.url);
        }
        if (page)
            ctx.updateEvent('context.page', page);
    }
    catch (e) {
        console.log(e);
    }
    try {
        const { properties } = ctx.event;
        if (properties === null || properties === void 0 ? void 0 : properties.referrer) {
            properties.referrer = (0, anonymizeResumeHash_1.anonymizeResumeHash)(properties.referrer);
        }
        if (properties === null || properties === void 0 ? void 0 : properties.search) {
            properties.search = (0, anonymizeResumeHash_1.anonymizeResumeHash)(properties.search);
        }
        if (properties === null || properties === void 0 ? void 0 : properties.url) {
            properties.url = (0, anonymizeResumeHash_1.anonymizeResumeHash)(properties.url);
        }
        if (properties)
            ctx.updateEvent('properties', properties);
    }
    catch (e) {
        console.log(e);
    }
    return ctx;
};
exports.filterResumeHashPlugin = {
    name: 'Filter resumeHash Plugin',
    type: 'enrichment',
    version: '1.0.0',
    isLoaded: () => true,
    load: () => Promise.resolve(),
    track: transform,
    page: transform,
    identify: transform,
};
//# sourceMappingURL=filterResumeHash.js.map